function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.3846 10.1933C35.3846 7.89215 34.3248 6.07642 32.2992 6.07642C30.265 6.07642 29.0342 7.89215 29.0342 10.1753C29.0342 12.8809 30.4872 14.2472 32.5727 14.2472C33.5897 14.2472 34.359 14.0045 34.9402 13.6629V11.8652C34.359 12.1708 33.6923 12.3596 32.8462 12.3596C32.0171 12.3596 31.2821 12.054 31.188 10.9933H35.3675C35.3675 10.8764 35.3846 10.409 35.3846 10.1933ZM31.1624 9.33934C31.1624 8.32361 31.7521 7.90114 32.2906 7.90114C32.812 7.90114 33.3675 8.32361 33.3675 9.33934H31.1624Z",
  fill: "#A9A2A2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.735 6.07642C24.8974 6.07642 24.359 6.4899 24.0598 6.77754L23.9487 6.22024H22.0684V16.7011L24.2051 16.2247L24.2137 13.6809C24.5214 13.9146 24.9744 14.2472 25.7265 14.2472C27.2564 14.2472 28.6496 12.9528 28.6496 10.1034C28.641 7.49664 27.2308 6.07642 25.735 6.07642ZM25.2222 12.2697C24.7179 12.2697 24.4188 12.0809 24.2137 11.8472L24.2051 8.51237C24.4273 8.2517 24.735 8.07192 25.2222 8.07192C26 8.07192 26.5385 8.98878 26.5385 10.1663C26.5385 11.3708 26.0085 12.2697 25.2222 12.2697Z",
  fill: "#A9A2A2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1282 5.54607L21.2735 5.06068V3.23596L19.1282 3.71237V5.54607Z",
  fill: "#A9A2A2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2735 6.22913H19.1282V14.0943H21.2735V6.22913Z",
  fill: "#A9A2A2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8291 6.89443L16.6923 6.22927H14.8462V14.0944H16.9829V8.7641C17.4872 8.07196 18.3419 8.19781 18.6068 8.29668V6.22927C18.3333 6.1214 17.3333 5.92365 16.8291 6.89443Z",
  fill: "#A9A2A2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5556 4.27869L10.4701 4.7461L10.4615 11.9461C10.4615 13.2764 11.4103 14.2562 12.6752 14.2562C13.3761 14.2562 13.8889 14.1214 14.1709 13.9596V12.1349C13.8974 12.2517 12.547 12.6652 12.547 11.3349V8.14386H14.1709V6.22925H12.547L12.5556 4.27869Z",
  fill: "#A9A2A2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.77778 8.51237C6.77778 8.16181 7.05128 8.02698 7.50428 8.02698C8.15385 8.02698 8.97436 8.23372 9.62393 8.60226V6.4899C8.91453 6.19327 8.21368 6.07642 7.50428 6.07642C5.76923 6.07642 4.61539 7.02923 4.61539 8.62024C4.61539 11.1011 7.86325 10.7056 7.86325 11.7753C7.86325 12.1888 7.52137 12.3236 7.04274 12.3236C6.33334 12.3236 5.42735 12.018 4.7094 11.6045V13.7438C5.50428 14.1034 6.30769 14.2562 7.04274 14.2562C8.82052 14.2562 10.0427 13.3304 10.0427 11.7214C10.0342 9.04271 6.77778 9.51912 6.77778 8.51237Z",
  fill: "#A9A2A2"
});

function SvgStripeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripeLogo.85205a46.svg";
export { ForwardRef as ReactComponent };